import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Device preference shared by every banner. Stored independently of account/challenge settings. */
@Injectable({ providedIn: 'root' })
export class BannerMotionPreferencesService implements OnDestroy {
    private readonly _key = 'Fitness.BannerAnimations';
    private readonly _enabled = new BehaviorSubject<boolean>(this.read());
    readonly enabled$ = this._enabled.asObservable();
    private readonly _storageChanged = (event: StorageEvent) => {
        if (event.key === this._key || event.key === null) { this._enabled.next(event.newValue !== 'false'); }
    };
    constructor() { if (typeof window !== 'undefined') { window.addEventListener('storage', this._storageChanged); } }
    get enabled(): boolean { return this._enabled.value; }
    toggle(): void {
        const value = !this.enabled;
        this._enabled.next(value);
        try { window.localStorage.setItem(this._key, String(value)); } catch (_) { /* Keep the session preference when storage is unavailable. */ }
    }
    private read(): boolean {
        try { return window.localStorage.getItem(this._key) !== 'false'; } catch (_) { return true; }
    }
    ngOnDestroy(): void { if (typeof window !== 'undefined') { window.removeEventListener('storage', this._storageChanged); } }
}
